import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-2',
    title: 'heading-s-bold md:heading-m-bold flex items-center justify-between',
    item: 'hover:bg-blue-light flex cursor-pointer items-center gap-3 py-2 md:px-2',
    icon: 'shrink-0 text-gray-500',
    text: 'heading-s line-clamp-1',
    removeAll: 'heading-s text-secondary-hover link tracking-wide',
    removeItem: 'flex-center ml-auto flex size-6 shrink-0 rounded-full bg-white'
  },
  variants: {
    color: {
      primary: 'text-black'
    },
    isRemovable: {
      true: {
        item: 'hover:bg-blue-light rounded-3xl'
      }
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
